import ChangelogPage from "./changelog-page";
export default ChangelogPage;
